module.exports = __webpack_public_path__ + "media/icons/widget-carq-badge@3x-d4ab2a37.svg";